module.exports = __webpack_public_path__ + "assets/img/fanganweinzi02.5b50b011.png";